import React, { Component } from 'react';
import store from '../store';
import ListUser from '../pages/User/ListUser';
import ListGroup from '../pages/Group/ListGroup';
class UsersAccess extends Component {
    constructor(props) {
        super(props);
        this.state = {
            Products: 'none',
            SendParameters: {},
            GroupAndUser: "User",
        };
        this.SelectMode=this.SelectMode.bind(this);
    }
    SelectMode(userorgroup) {
        this.setState({
            GroupAndUser: userorgroup
        });
    }
    render() {
        store.dispatch({ type: 'useraccess' });
        return (
            <div>
                <table><tbody>
                    <tr>
                        <td><button className="btn btn-outline-success" type="button"
                            style={{ "backgroundColor": "#e3f2fd", 'marginLeft': '10px' }}
                            onClick={()=>this.SelectMode("User")}
                        > مدیریت کاربران </button></td>
                        <td><button className="btn btn-outline-success" type="button"
                            style={{ "backgroundColor": "#e3f2fd", 'marginLeft': '10px' }}
                            onClick={()=>this.SelectMode("Group")}
                        > مدیریت گروهها </button></td>
                    </tr>
                </tbody></table>
                {
                    this.state.GroupAndUser === "User" ? <div><ListUser /></div> : null
                }
                {
                    this.state.GroupAndUser === "Group" ? <div><ListGroup /></div> : null
                }
            </div>
        )
    }
}
export default (UsersAccess);



// WEBPACK FOOTER //
// ./src/pages/UsersAccess.js